<template>
  <section class="p-xs-0 p-lg-5">
    <div class="container py-5">
      <h5 class="text-center">
        Para brindarte un servicio personalizado y eficiente, <br />
        solo requerimos tres simples pasos.
      </h5>

      <div
        class="col-md-10 mx-auto my-4"
        style="
          border-radius: 50px;
          box-shadow: 15px 14px 14px -8px rgba(20, 20, 20, 0.25) !important;
        "
      >
        <div class="row py-5">
          <div class="col-md-4 border-end">
            <div class="text-center">
              <h1 class="fw-bolder text-warning">1</h1>
              <h5 class="fw-bolder text-dark">Verificación de datos</h5>
            </div>
          </div>
          <div class="col-md-4 border-end">
            <div class="text-center">
              <h1 class="fw-bolder text-warning">2</h1>
              <h5 class="fw-bolder text-dark">
                Detalles personales<br />
                y de la empresa
              </h5>
            </div>
          </div>
          <div class="col-md-4">
            <div class="text-center">
              <h1 class="fw-bolder text-warning">3</h1>
              <h5 class="fw-bolder text-dark">
                Información del activo y<br />
                condiciones de arrendamiento
              </h5>
            </div>
          </div>
        </div>
      </div>

      <div class="text-center text-dark">
        <p>
          Comenzamos por cuidar tus datos y asegurarnos de que tu<br />cotización*
          llegue de manera inmediata cuando la solicites.
        </p>
        <small>* Esta cotización es de carácter informativo.</small>
      </div>
    </div>
  </section>
</template>
